import { KeyboardEvent } from 'react';

export const onEnter = (cb: () => void, chained?: () => void) => (e: KeyboardEvent) => {
  if (e.code === 'Enter' || e.code === 'NumpadEnter') {
    cb();
  } else {
    if (chained) {
      chained();
    }
  }
};
